<template>
  <div class="form-error-result">
    <div class="form-error-result__content">
      <svg class="form-error-result__img" width="99" height="99" viewBox="0 0 99 99" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="49.5" cy="49.5" r="49.5" fill="currentColor" />
        <path d="M33.1484 66L65.1484 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
        <path d="M65 66L33 34" stroke="white" stroke-width="5" stroke-linejoin="round" />
      </svg>

      <h3 class="form-error-result__title">{{ title }}</h3>
      <div class="form-error-result__text">{{ text }}</div>

      <div class="form-error-result__actions">
        <slot name="error-actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormErrorResult',
  props: {
    title: {
      type: String,
      default: window.staticText.modal.errorTitle,
    },
    text: {
      type: String,
      default: window.staticText.modal.errorText,
    },
  },
}
</script>

<style lang="sass">
.form-error-result
  margin-top: 48px
  min-width: 200px

  &__title
    margin-top: 32px
    line-height: 34px
    font-size: 28px

  &__text
    margin-top: 16px
    font-size: 19px
    line-height: 140%
    margin-bottom: 88px

  &__title, &__text
    color: #ffffff

  &__img
    color: #ED8E8E

  &__actions
    display: flex
    gap: 16px
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/components/FormErrorResult.vue